export default __webpack_public_path__ + "static/media/template4.c858c093.svg";